import { render, staticRenderFns } from "./AvailableOrderFooter.vue?vue&type=template&id=1c761a89&"
import script from "./AvailableOrderFooter.vue?vue&type=script&lang=js&"
export * from "./AvailableOrderFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports